import { useListStore, useRegistrationStore } from '../../hooks';
import { CrawlerHeaderView } from '../../components/CrawlerHeaderView';

export const CrawlerHeader = () => {
  const { onOpenModal } = useRegistrationStore();
  const { searchValue, changeSearchValue } = useListStore();

  return (
    <CrawlerHeaderView
      searchValue={searchValue}
      handleSearchValueChange={changeSearchValue}
      handleClickRegistration={onOpenModal}
    />
  );
};
